import type {ReactNode} from 'react';
import {useEffect, useState} from 'react';
import {Provider} from 'urql';

import {makeUrqlClient} from '@/config/urql-client';
import {useAuthenticationStore} from '@/hooks/global-stores/authentication.store';

type Props = {
  children: ReactNode;
};

export const URQLProvider = ({children}: Props) => {
  const [client, setClient] = useState(() => makeUrqlClient());
  const token = useAuthenticationStore(state => state.accessToken);

  useEffect(() => {
    setClient(makeUrqlClient());
  }, [token]);

  return <Provider value={client}>{children}</Provider>;
};
